import React from "react";

interface MoreIconProps {
  className?: string;
  fillColor?: string;
  id?: string;
  ariaLabel?: string;
}

const MoreIcon: React.FC<MoreIconProps> = ({
  className = "",
  fillColor = "#9BB6C2",
  id,
  ariaLabel,
}) => {
  return (
    <svg
      id={id}
      aria-label={ariaLabel}
      role={ariaLabel ? "img" : undefined}
      className={`w-4 h-4 text-[#9BB6C2] ${className}`}
      viewBox="0 0 60 60"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill={fillColor}>
        <path d="M8,22c-3.314,0-6,2.686-6,6s2.686,6,6,6s6-2.686,6-6S11.314,22,8,22z" />
        <path d="M52,22c-3.314,0-6,2.686-6,6s2.686,6,6,6s6-2.686,6-6S55.314,22,52,22z" />
        <path d="M30,22c-3.314,0-6,2.686-6,6s2.686,6,6,6s6-2.686,6-6S33.314,22,30,22z" />
      </g>
    </svg>
  );
};

export default MoreIcon;
